module.exports = __webpack_public_path__ + "static/white_bg3-f4edc1430981b273a383fe3da798b4dd.png";